import { Pipe, PipeTransform } from '@angular/core';
import { DocumentSessionPartial } from '@domain';

/**
 * Soma o tamanho (em GB) de um documento a partir das suas seções.
 *
 * O campo `sizeGB` do documento deixou de existir no backend (refactor de tokens):
 * a API não envia mais nada no nível do documento, então o card exibia sempre "0 B".
 * A fonte de verdade passou a ser o `size` de cada seção — o MESMO valor mostrado no
 * card da seção dentro do editor —, mantido pela API a cada inclusão/troca/remoção
 * de item. Assim o total do card sempre bate com a soma das seções que o usuário vê.
 *
 * Fallback: se uma seção vier sem `size` (dado antigo/incompleto), soma o `size` dos
 * seus itens — nos grupos (GROUP_IMAGE/GROUP_VIDEO) o `size` do item já é o total do
 * grupo.
 */
export function computeDocumentSizeGB(
    sessions: DocumentSessionPartial[] | null | undefined
): number {
    let total = 0;

    for (const session of sessions ?? []) {
        if (Number.isFinite(session?.size)) {
            total += session.size;
            continue;
        }

        for (const item of session?.items ?? []) {
            total += Number.isFinite(item?.size) ? item.size : 0;
        }
    }

    return total;
}

@Pipe({
    name: 'documentSizeGB',
    standalone: true,
})
export class DocumentSizeGBPipe implements PipeTransform {
    transform(sessions: DocumentSessionPartial[] | null | undefined): number {
        return computeDocumentSizeGB(sessions);
    }
}
